"use client";

import { useGlobalModalContext } from "@components/GlobalModalProvider/GlobalModalProvider";
import { useSearchParams } from "next/navigation";
import { ModalTypes } from "@lib/enums/ModalTypes";
import { useEffect } from "react";

export default function SupportForm() {
    const query = useSearchParams();
    const showContactForm = query?.get("support-form");
    const { showModal, isReady } = useGlobalModalContext();

    useEffect(() => {
        if (isReady && showContactForm === "true") {
            showModal(ModalTypes.contactForm);
        }
    }, [isReady, showContactForm, showModal]);

    return null;
}
